export const APP_NAME = 'TournNext';
export const TAGLINE = 'Precision Play. Next-Gen Flow.';
